/* src/app/shared/components/ship-details/ship-details-print-dialog/ship-details-print-dialog.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.ship-details-print-dialog .no-print {
  display: none;
}
.ship-details-print-dialog .flex-center {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.ship-details-print-dialog .fill-height,
.ship-details-print-dialog .white-sheet-content,
.ship-details-print-dialog .white-content-page {
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -ms-flex-line-pack: stretch;
  align-content: stretch;
}
.ship-details-print-dialog .page-center,
.white-content-page .ship-details-print-dialog .ups-page-header,
.white-content-page .ship-details-print-dialog .ups-content-block,
.ship-details-print-dialog .white-sheet-content,
.ship-details-print-dialog .white-content-page .ups-page-header,
.ship-details-print-dialog .white-content-page .ups-content-block {
  min-width: 23.5375em;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.ship-details-print-dialog .white-sheet-content {
  background-color: white;
}
.ship-details-print-dialog .white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
.ship-details-print-dialog .white-content-page {
  background-color: white;
  min-height: 100%;
}
.ship-details-print-dialog .white-content-page .ups-page-header {
  padding-bottom: 1em;
}
.ship-details-print-dialog .white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.ship-details-print-dialog .ship-details {
  width: 100%;
  font-size: 1rem;
  font-family: "Roboto Flex", sans-serif;
}
.ship-details-print-dialog .ship-details .ship-details-content {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.ship-details-print-dialog .ship-details .ship-details-content .section.tracking-details {
}
.ship-details-print-dialog .ship-details .ship-details-content .section.commodities {
}
.ship-details-print-dialog .ship-details .ship-details-content .section.shipment-information {
}
.ship-details-print-dialog .ship-details .ship-details-content .tracked-shipment-info {
}
.ship-details-print-dialog .ship-details .ship-details-content .section.shipment-information .content-items-title {
  margin-top: 0.8em;
}
.ship-details-print-dialog .ship-details .tracking-details-table {
  position: relative;
  visibility: hidden;
  opacity: 0;
  max-height: 0;
  transition: all 0.3s ease-in-out;
}
.ship-details-print-dialog .ship-details .tracking-details-table.visible {
  visibility: visible;
  opacity: 1;
  min-height: 5em;
  max-height: 25em;
  overflow-y: auto;
}
.ship-details-print-dialog .ship-details .tracking-details-table .dataTables_wrapper {
  padding: 0;
}
.ship-details-print-dialog .ship-details .tracked-shipment-info {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.ship-details-print-dialog .ship-details .tracked-shipment-info > .tracked-shipment-info-section {
}
.ship-details-print-dialog .ship-details .tracked-shipment-info .payment-information {
  order: 2;
}
.ship-details-print-dialog .ship-details .tracked-shipment-info .special-services {
  order: 1;
}
.ship-details-print-dialog .ship-details .commodities {
  width: 100%;
}
.ship-details-print-dialog .ship-details .commodities .dataTables_wrapper {
  padding: 0;
}
.ship-details-print-dialog .ship-details .commodities .dataTables_wrapper tfoot {
  font-weight: 700;
}
.ship-details-print-dialog .ship-details .section {
  margin-bottom: 0;
}
.ship-details-print-dialog .ship-details .section.tracking-details .section-content .content-items {
  width: 100%;
}
.ship-details-print-dialog .ship-details .section.tracking-details .section-content .content-items .content-item .value .link {
  margin: 0 1em;
}
.ship-details-print-dialog .ship-details .section.notifications .notification {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  border: solid thin #e8e8e6;
  border-radius: 3px;
  padding: 1.25rem 1.25rem 1.25rem 0.90625rem;
  font-size: 0.75rem;
  margin-bottom: 2em;
  line-height: 1.5;
}
.ship-details-print-dialog .ship-details .section.notifications .notification::before {
  margin-right: 0.78125rem;
  width: 1.375rem;
  height: 1.375rem;
  zoom: 1.5;
}
.ship-details-print-dialog .ship-details .section.notifications .notification.alert {
  color: #d50000;
  border-color: #d50000;
}
.ship-details-print-dialog .ship-details .section.notifications .notification.alert::before {
  content: url("data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2217%22 height%3D%2216%22 viewBox%3D%220 0 17 16%22%3E %3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22 stroke%3D%22%23D50000%22 stroke-linejoin%3D%22round%22%3E %3Cpath stroke-linecap%3D%22round%22 d%3D%22M8.5 10.308v-4.99M15.674 14.674H1.326L8.5.326z%22%2F%3E %3Cpath d%3D%22M8.826 12.391a.326.326 0 1 1-.652 0 .326.326 0 0 1 .652 0z%22%2F%3E %3C%2Fg%3E%3C%2Fsvg%3E");
}
.ship-details-print-dialog .ship-details .section.notifications .notification .notification-content {
  font-size: 0.75rem;
}
.ship-details-print-dialog .ship-details .section.notifications .notification .notification-content h5,
.ship-details-print-dialog .ship-details .section.notifications .notification .notification-content h6,
.ship-details-print-dialog .ship-details .section.notifications .notification .notification-content .mat-mdc-checkbox,
.ship-details-print-dialog .ship-details .section.notifications .notification .notification-content p {
  font-size: 1em;
}
.ship-details-print-dialog .ship-details .section.notifications .notification .notification-content h5,
.ship-details-print-dialog .ship-details .section.notifications .notification .notification-content h6 {
  margin-top: 0;
}
.ship-details-print-dialog .ship-details .section.notifications .notification .notification-content p {
  margin-bottom: 0;
}
.ship-details-print-dialog .ship-details .section.notifications .notification .mat-mdc-form-field-error {
  margin-top: 1em;
}
.ship-details-print-dialog .ship-details .section.notifications .reroute p {
  margin-top: 1em;
}
.ship-details-print-dialog .ship-details .section.notifications p {
  font-size: 0.8em;
}
.ship-details-print-dialog .ship-details .section.payment-bill-to .content-items .content-item.bill-to {
  margin: 10px 0 37px 0;
  padding-top: 0;
}
.ship-details-print-dialog .ship-details .section.payment-information {
  margin-top: -2em;
}
.ship-details-print-dialog .ship-details .section.total-payment {
}
.ship-details-print-dialog .ship-details .section.total-payment .content-items .content-item .key {
  width: 13em;
}
.ship-details-print-dialog .ship-details .section.total-payment .content-items .content-item .value {
  width: 8em;
}
.ship-details-print-dialog .ship-details .section.total-payment .content-items .content-item.total {
  border-top: 2px solid #d9d9d6;
  font-weight: 700;
  padding-top: 1em;
  margin-top: 1em;
}
.ship-details-print-dialog .ship-details .section.total-payment .content-items .content-item.total .key {
  text-align: right;
  padding-right: 2em;
}
.ship-details-print-dialog .ship-details .section-title {
  font-family: "Roboto Flex", sans-serif;
  color: rgba(36, 36, 36, 0.87);
  font-size: 1.125em;
  font-weight: 600;
}
.ship-details-print-dialog .ship-details .section-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  font-size: 0.875em;
}
.ship-details-print-dialog .ship-details .section-content .content-items {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 1em;
}
.ship-details-print-dialog .ship-details .section-content .content-items.payment-information .content-item .key {
  width: 13em;
}
.ship-details-print-dialog .ship-details .section-content .content-items.payment-information .content-item.schedule-pickup .key {
  font-weight: 700;
}
.ship-details-print-dialog .ship-details .section-content .content-items .content-items-title {
  font-family: "Roboto Flex", sans-serif;
  font-weight: 700;
}
.ship-details-print-dialog .ship-details .section-content .content-items .content-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0.5em 0;
  width: 23em;
}
.ship-details-print-dialog .ship-details .section-content .content-items .content-item .key,
.ship-details-print-dialog .ship-details .section-content .content-items .content-item .value {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.ship-details-print-dialog .ship-details .section-content .content-items .content-item .value {
  font-weight: 700;
  white-space: nowrap;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  text-align: right;
}
.ship-details-print-dialog .ship-details .section-content .content-items .content-item .value a {
  line-height: 1;
}
.ship-details-print-dialog .upsc-table thead {
  display: none;
}
.ship-details-print-dialog .upsc-table tbody {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}
.ship-details-print-dialog .upsc-table tbody tr {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}
.ship-details-print-dialog .upsc-table tbody tr td {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}
.ship-details-print-dialog .upsc-table tbody tr td:not(:first-of-type) {
  border-top-width: 0;
}
.ship-details-print-dialog .upsc-table tbody tr td .column-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  margin-right: 1em;
  font-weight: 700;
}
.ship-details-print-dialog .upsc-table tbody tr td .column-header::after {
  content: ":";
}
.ship-details-print-dialog .mat-mdc-table {
  display: table !important;
  width: 100%;
}
.ship-details-print-dialog .mat-mdc-table > .mat-mdc-header-row,
.ship-details-print-dialog .mat-table > .mat-mdc-row {
  display: table-row;
  padding: 0;
  border: none;
}
.ship-details-print-dialog .mat-mdc-table > .mat-mdc-header-row > .mat-mdc-header-cell,
.ship-details-print-dialog .mat-table > .mat-header-row > .mat-mdc-cell,
.ship-details-print-dialog .mat-table > .mat-mdc-row > .mat-header-cell,
.ship-details-print-dialog .mat-table > .mat-row > .mat-cell {
  display: table-cell;
  height: 48px;
  vertical-align: middle;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.ship-details-print-dialog .dataTables_wrapper {
  width: 100%;
  overflow: auto;
  font-size: 1rem;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable {
  border: solid thin #f4f4f4;
  width: 100%;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable.no-footer {
  border-bottom: solid thin #f4f4f4;
  width: 100%;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable.stripe thead tr,
.ship-details-print-dialog .dataTables_wrapper table.dataTable.stripe tbody tr {
  height: 3.125em;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable.stripe thead tr th,
.ship-details-print-dialog .dataTables_wrapper table.dataTable.stripe thead tr td,
.ship-details-print-dialog .dataTables_wrapper table.dataTable.stripe tbody tr th,
.ship-details-print-dialog .dataTables_wrapper table.dataTable.stripe tbody tr td {
  white-space: nowrap;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable.stripe thead {
  background-color: #d9d9d6;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable.stripe thead tr th {
  font-size: 0.9375em;
  color: #595555;
  border-bottom: none;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable.stripe tbody {
  border-bottom: none;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable.stripe tbody tr.odd {
  background-color: white;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable.stripe tbody tr.even {
  background-color: #f4f4f4;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable.stripe tbody tr td {
  font-size: 0.8125em;
  color: #4a4a4a;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable.stripe tbody tr td .actions {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable.stripe tbody tr td .actions .mat-mdc-raised-button {
  line-height: 2.35em;
  height: 1.875rem;
  margin: 0 0.5231em;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable.compact thead tr {
  height: 1.75em;
  background-color: #f4f4f4;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable.compact thead tr th {
  font-size: 0.6875em;
  color: #595555;
  border-bottom: none;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable.compact tbody tr {
  height: 2.39375em;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable.compact tbody tr td {
  font-size: 0.8125em;
  color: rgba(36, 36, 36, 0.87);
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable tbody tr td.dataTables_empty {
  width: 100%;
  text-align: center;
  padding-top: 1rem;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable thead {
  background-color: #d9d9d6;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable th,
.ship-details-print-dialog .dataTables_wrapper table.dataTable td {
  visibility: visible;
  opacity: 1;
  transition: visibility 0.3s ease, opacity 0.3s ease;
}
.ship-details-print-dialog .dataTables_wrapper table.dataTable th[hidden],
.ship-details-print-dialog .dataTables_wrapper table.dataTable td[hidden] {
  display: table-cell;
  visibility: collapse;
  opacity: 0;
  max-width: 0;
  padding: 0;
}
/*# sourceMappingURL=ship-details-print-dialog.component.css.map */
